import { Box, ButtonBase, Typography, useTheme } from "@mui/material";

// ----------------------------------------------------------------------

interface AdminToggleProps {
  checked: boolean;
  onChange: () => void;
  label?: string;
  disabled?: boolean;
}

/** Pill toggle para células de tabela admin (on/off). */
export default function AdminToggle({ checked, onChange, label, disabled = false }: AdminToggleProps) {
  const theme = useTheme();

  return (
    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
      <ButtonBase
        aria-pressed={checked}
        disabled={disabled}
        onClick={onChange}
        sx={{
          width: 40,
          height: 22,
          borderRadius: "100px",
          backgroundColor: checked ? "primary.main" : theme.palette.brand.toggleOff,
          transition: "background-color .15s",
          flexShrink: 0,
          position: "relative",
          opacity: disabled ? 0.5 : 1,
          cursor: disabled ? "not-allowed" : "pointer",
        }}
      >
        <Box
          sx={{
            width: 18,
            height: 18,
            borderRadius: "50%",
            backgroundColor: "#FFFFFF",
            position: "absolute",
            top: 2,
            left: checked ? 20 : 2,
            transition: "left .15s",
            boxShadow: "0 1px 3px rgba(0,0,0,0.18)",
          }}
        />
      </ButtonBase>
      {label && (
        <Typography
          component="span"
          sx={{ fontSize: "12.5px", color: checked ? "text.primary" : "text.secondary" }}
        >
          {label}
        </Typography>
      )}
    </Box>
  );
}
